import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "gfu-layout-wrapper" }
const _hoisted_2 = { class: "gfu-grid gfu-grid--gutter" }
const _hoisted_3 = { class: "gfu-grid__cell gfu-1of3--l gfu-4of6--m gfu-1of1" }
const _hoisted_4 = { class: "gfu-box gfu-box--thick _mt-6 _mb-3" }
const _hoisted_5 = { class: "gfu-heading gfu-heading--soft gfu-box__title" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { class: "_tac" }
const _hoisted_8 = { class: "gfu-fields" }
const _hoisted_9 = { class: "_tac _mt-6" }
const _hoisted_10 = {
  key: 1,
  class: "gfu-box--error _tac"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_field = _resolveComponent("field")
  const _component_base_button = _resolveComponent("base-button")
  const _component_progress_overlay = _resolveComponent("progress-overlay")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[2] || (_cache[2] = _createElementVNode("div", { class: "gfu-grid__cell gfu-1of3--l gfu-1of6--m gfu-1of1" }, null, -1 /* CACHED */)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h1", _hoisted_5, _toDisplayString(_ctx.Resources.ResetPassword.ResetPasswordHeader), 1 /* TEXT */),
          ($options.canChangePassword)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createElementVNode("p", _hoisted_7, _toDisplayString($options.getMessage), 1 /* TEXT */),
                _createElementVNode("div", null, [
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("fieldset", null, [
                      _createVNode(_component_field, {
                        name: "model.newPassword",
                        "display-name": _ctx.Resources.ResetPassword.NewPasswordFieldLabel
                      }, {
                        default: _withCtx(() => [
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (($data.model.newPassword) = $event)),
                            class: "gfu-field__input",
                            type: "password",
                            name: "newPassword"
                          }, null, 512 /* NEED_PATCH */), [
                            [_vModelText, $data.model.newPassword]
                          ])
                        ]),
                        _: 1 /* STABLE */
                      }, 8 /* PROPS */, ["display-name"]),
                      _createVNode(_component_field, {
                        name: "model.repeatNewPassword",
                        "display-name": _ctx.Resources.ResetPassword.RepeatPasswordFieldLabel
                      }, {
                        default: _withCtx(() => [
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => (($data.model.repeatNewPassword) = $event)),
                            class: "gfu-field__input",
                            type: "password",
                            name: "repeatNewPassword"
                          }, null, 512 /* NEED_PATCH */), [
                            [_vModelText, $data.model.repeatNewPassword]
                          ])
                        ]),
                        _: 1 /* STABLE */
                      }, 8 /* PROPS */, ["display-name"]),
                      _createElementVNode("div", _hoisted_9, [
                        _createVNode(_component_field, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_base_button, {
                              theme: "accent",
                              display: "block",
                              width: "wide",
                              onClick: $options.submit
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.Resources.ResetPassword.ResetPasswordSubmitButton), 1 /* TEXT */)
                              ]),
                              _: 1 /* STABLE */
                            }, 8 /* PROPS */, ["onClick"])
                          ]),
                          _: 1 /* STABLE */
                        })
                      ])
                    ])
                  ]),
                  _createVNode(_component_progress_overlay, { visible: _ctx.isProcessing }, null, 8 /* PROPS */, ["visible"])
                ])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_10, [
                _createElementVNode("p", null, _toDisplayString($options.getMessage), 1 /* TEXT */)
              ]))
        ])
      ]),
      _cache[3] || (_cache[3] = _createElementVNode("div", { class: "gfu-grid__cell gfu-1of3--l gfu-1of6--m gfu-1of1" }, null, -1 /* CACHED */))
    ])
  ]))
}